'use strict';

// file-dropzone/click.js — клик через label работает нативно, тут только keydown

jQuery(document).on('keydown', '.file-dropzone', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        // Любой file-инпут внутри зоны (см. drag.js).
        let input = this.querySelector('input[type=file]');
        if (input) input.click();
    }
});